var _ellipse, _polyline, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLampLoad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.25,
    height: 16.25,
    viewBox: "0 0 16.25 16.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lamp Load") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.12,
    cy: 8.13,
    rx: 4.56,
    ry: 4.81,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "0.13 7.57 5.12 7.57 5.79 5.74 6.7 8.54 7.49 6.37 8.46 8.54 9.49 5.74 10.78 8.54 11.13 7.57 16.13 7.57",
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.22 12.08) scale(0.95 1)",
    fontSize: 3.92,
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "Calibri",
    style: {
      isolation: "isolate"
    }
  }, "B"), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.13,
    y: 0.13,
    width: 16,
    height: 16,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampLoad);
export default __webpack_public_path__ + "static/media/LampLoad.37dc77cb62d6b92f3171fbc6e686a0e0.svg";
export { ForwardRef as ReactComponent };